// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading svg {\n  width: 40px;\n  height: 40px;\n}\n.loading path {\n  fill: config(\"colors.blue-500\");\n}", ""]);
// Exports
module.exports = exports;
